<template>
  <div class="subscription-create">
    <h2>{{ mode === 'edit' ? '청약 수정' : '청약 등록' }}</h2>

    <form @submit.prevent="submitSubscription">
      <div class="form-group">
        <label for="title">제목</label>
        <input type="text" id="title" v-model="form.title" required />
      </div>

      <div class="form-group">
        <label for="description">설명</label>
        <ToastEditor v-model="form.description" />
      </div>

      <div class="form-group">
        <label>청약 타입</label>
        <div class="checkbox-group">
          <label>
            <input type="checkbox" value="GENERAL-15" v-model="form.subscriptionType" />
            15형 청년 일반공급
          </label>
          <label>
            <input type="checkbox" value="SPECIAL-15" v-model="form.subscriptionType" />
            15형 청년 특별공급
          </label>
          <label>
            <input type="checkbox" value="GENERAL-30" v-model="form.subscriptionType" />
            30형 청년&신혼부부 일반공급
          </label>
        </div>
      </div>

      <div class="form-group">
        <label for="notice_at">공고일</label>
        <input type="date" id="notice_at" v-model="form.noticeAt" required />
      </div>
      <div class="form-group">
        <label for="start_ts">시작일시</label>
        <input type="datetime-local" id="start_ts" v-model="form.startTs" required />
      </div>

      <div class="form-group">
        <label for="end_ts">종료일시</label>
        <input type="datetime-local" id="end_ts" v-model="form.endTs" required />
      </div>

      <div class="button-row">
        <button @click="goBack" type="button" class="back-button">취소</button>
        <button type="submit">{{ mode === 'edit' ? '수정' : '등록' }}</button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import axios from '@/utils/axios';
import ToastEditor from '@/components/ToastEditor.vue';

// ✅ 라우터 사용
const router = useRouter();
const route = useRoute();

// ✅ form 데이터
const form = ref({
  title: '',
  description: '',
  subscriptionType: [],
  noticeAt: '',
  startTs: '',
  endTs: ''
});

const goBack = (() => {
  router.push('/admin')
})
// ✅ 수정 모드 확인
const mode = ref(route.params.id ? 'edit' : 'create');
const subscriptionId = route.params.id;

// ✅ 수정 모드일 경우 데이터 로딩
onMounted(() => {
  if (mode.value === 'edit' && subscriptionId) {
    loadSubscription();
  }
});

// ✅ 기존 데이터 불러오기
const loadSubscription = async () => {
  try {
    const response = await axios.get(`/bx201/subscription/${subscriptionId}`);
    const data = response.data;

    form.value.title = data.title;
    form.value.description = data.description;
    form.value.subscriptionType = data.subscriptionType;
    form.value.noticeAt = data.noticeAt;
    form.value.startTs = data.startTs;
    form.value.endTs = data.endTs;

  } catch (error) {
    alert("청약 데이터를 불러오지 못했습니다.");
  }
};

// ✅ 제출 처리
const submitSubscription = async () => {
  try {
    if (mode.value === 'edit') {
      await axios.put(`/bx201/admin/subscription/${subscriptionId}`, form.value);
      alert('청약 수정 완료!');
    } else {
      await axios.post('/bx201/admin/subscription', form.value);
      alert('청약 등록 완료!');
    }
    router.push('/admin');
  } catch (error) {
    // ✅ 이미 진행중인 청약이 있을 때
    if (error.response && error.response.status === 409) {
      alert('이미 진행 중인 청약이 있습니다. 기존 청약이 종료된 후 등록할 수 있습니다.');
      return;
    }
    // 그 외 에러
    alert('청약 저장 실패');
  }
};
</script>

<style scoped>
.subscription-create {
  max-width: 700px;
  margin: 80px auto;
  padding: 0 16px;
}

form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 6px;
  font-weight: bold;
}

input,
textarea {
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
}

button {
  padding: 6px 12px;
  font-size: 0.9rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.button-row {
  display: flex;
  gap: 10px;  /* 버튼 사이 간격 */
  margin-top: 20px; /* 필요시 위 여백 */
}
</style>
